<template>
  <el-dialog :title="title" :visible.sync="dialogstoreVisible" custom-class="full-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <div ref="print1">
      <el-row>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="18">
              <el-select v-model="datetype" v-if="false" placeholder="请选择" style="width:120px;"  size="mini">
                <el-option
                  :label="'按确认日期'"
                  :value="'10'">
                </el-option>
                <el-option
                  :label="'按发货日期'"
                  :value="'20'">
                </el-option>
              </el-select>
              <el-date-picker
                v-model="searchdatevalue"  size="mini"
                type="daterange" :value-format="'yyyy-MM-dd'"
                align="left" :unlink-panels="true"
                range-separator="至" :clearable="false"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:255px">
              </el-date-picker>
              <el-input style="width:120px;"
                        placeholder="订单号"
                        v-model="erpserial"  size="mini">
              </el-input>
              <el-input style="width:125px;height: 40px" placeholder="选商品" v-model="seedname"
                        @click.native="showGoodDetailSel" size="mini">
              </el-input>
              <el-select v-model="paymethod" placeholder="支付方式" style="width: 115px"  size="mini">
                <el-option label="支付方式" value=""></el-option>
                <el-option label="按合同结算" value="按合同结算"></el-option>
                <el-option label="微信" value="微信"></el-option>
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option label="余额" value="余额"></el-option>
                <el-option label="优惠券" value="优惠券"></el-option>
              </el-select>
              <!--<el-input-number placeholder="球镜" style="width:100px;" v-model="startY"  size="mini" :step="0.25" :precision="2" controls-position="right">-->
              <!--</el-input-number>-->
              <!--<el-input-number placeholder="柱镜" style="width:100px;" v-model="startX"  size="mini" :step="0.25" :precision="2" controls-position="right">-->
              <!--</el-input-number>-->
            </el-col>
            <el-col :span="6" style="margin-top: 5px;">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid"  size="mini">搜索</el-button>
            </el-col>
          </el-col>
        </div>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-table v-if="dialogstoreVisible"
                      :data="tableData"
                      :height="eltableheight"
                      size="mini"
                      stripe
                      border
                      style="width: 100%;">
              <el-table-column
                width="60" fixed
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="handleoverdate"
                label="发货日期"
                align="center"
                header-align="center"
                width="140">
              </el-table-column>
              <el-table-column
                prop="statusname"
                label="状态"
                align="left"
                header-align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="erpserial"
                label="订单号"
                align="center"
                header-align="center" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.erpserial }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center"
                width="220">
                <template slot-scope="scope">
                  {{ scope.row.seedname }}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="产品编码" :show-overflow-tooltip="true"
                align="left"
                header-align="center"
                width="140">
              </el-table-column>
              <el-table-column
                prop="packagesize"
                label="规格"
                align="left"
                header-align="center"
                width="105">
                <template slot-scope="scope">
                  {{getPackagesize(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="left"
                header-align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="saleprice" v-if="showlookprice"
                label="销售单价"
                align="right"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  {{(scope.row.salemoney/scope.row.totalnumber)|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="salemoney" v-if="showlookprice"
                label="销售金额"
                align="right"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.salemoney|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="discount" v-if="showlookprice"
                label="折扣"
                align="right"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.discount|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="pricetax" v-if="showlookprice"
                label="实收单价"
                align="right"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  {{(scope.row.totalmoneytax/scope.row.totalnumber)|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="totalmoneytax" v-if="showlookprice"
                label="实收金额"
                align="right"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.totalmoneytax|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="rebate"
                label="返利"
                align="right"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.rebate|numeric(2)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注" :show-overflow-tooltip="true"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  {{getLiuYan(scope.row.remark)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="uname"
                align="left"
                header-align="center"
                label="下单人" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column
                prop="paymethod"
                label="支付方式"
                align="left" :show-overflow-tooltip="true"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{ scope.row.yfk==0&&scope.row.htje!=0?'按合同结算': ((scope.row.yfk==0&&scope.row.htje==0)?"已支付(优惠券)":
                  scope.row.paymethod) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="htqd"
                label="支付时间"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.htqd }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="confirmeddate"
                label="订单确认"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.confirmeddate }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="applybydname"
                label="服务商"
                align="left" :show-overflow-tooltip="true"
                header-align="center"
                width="200">
              </el-table-column>
              <el-table-column
                prop="logisticsco"
                label="快递公司"
                align="left"
                header-align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="logisticsnum"
                label="快递单号"
                align="left"
                header-align="center" :show-overflow-tooltip="true"
                width="120">
              </el-table-column>
              <el-table-column
                prop="parenterpserial"
                label="原订单号"
                align="left"
                header-align="center"
                width="120">
              </el-table-column>
              <el-table-column
                label="查看" fixed="right"
                align="right"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="lookOrder(scope.$index, scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="选择" fixed="right"
                align="right"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  <el-button
                    size="mini" v-if="scope.row.totalnumber>0"
                    @click="selectOrder(scope.$index, scope.row)">选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="foot" :style="{textAlign:'center' }">
              <Pagination ref="pagination1" @bindgrid="bindGrid('pagination')" :pagination="pagination"></Pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <CstagreementEdit ref="DataDetail" @bindGrid="bindGrid"></CstagreementEdit>
      <CstagreementMachiningEdit ref="machiningDetail"></CstagreementMachiningEdit>
      <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    </div>
  </el-dialog>
</template>
<script>
  import {customerSee4Order} from '@/api/set/jiesuan';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import {ConvertMoney, pickerShortCuts} from '@/plugin/ordercommon';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import CstagreementMachiningEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import {getRemark, getKHRemark} from '@/plugin/ordercommon'
  import {printing} from '@/api/set/csagreement';


  export default {
    name: '',
    data() {
      return {
        puhuo: "",
        orderNum:null,
        setofbooks: '',
        text: {},
        temp: [],
        title:'',
        type: 'sale',
        formLabelWidth: '120px',
        eltableheight: 300,
        seen: false,
        dialogstoreVisible: false,
        loading: true,
        searchdatevalue: '',
        tableData: [],
        applybydserial: '',
        applybydserials: '',
        customerserial: '',
        customername:'',
        paymethod:'',
        searchremark:'',
        datetype: '20',
        searchtype: '',
        searchstatus: '1',
        erpserial: '',
        seedcode: '',
        seedname: '',
        categorycode: '',
        categoryname: '',
        startmoney: '',
        endmoney: '',
        startY: undefined,
        startX: undefined,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
      }
    },
    props:{
      showlookprice:false
    },
    methods: {
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        if (ps.X) {
          return 'S:' + ps.Y + ',C:' + ps.X;
        } else {
          return ps.M + '-' + ps.C;
        }
      },
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },
      initData(customerserial, customername, seedcode,seedname, totalnum) {
        this.customerserial = customerserial
        this.customername = customername
        this.title = customername;
        this.seedcode = seedcode;
        this.seedname=seedname;
        this.startX = undefined
        this.startY = undefined
        this.tableData = []
        this.dialogstoreVisible = true
        this.orderNum == null;
        if (totalnum && totalnum > 0) {
          this.orderNum = totalnum;
        }
        this.bindGrid();
      },
      bindGrid(param) {
        if ((this.startX || parseFloat(this.startX) == 0 || this.startY || parseFloat(this.startY) == 0) && !this.seedcode) {
          this.$message({
            message: '商品 必须选择！',
            type: 'warning'
          })
          return;
        }
        this.tableData = []
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        customerSee4Order({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          datetype: this.datetype,
          begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
          enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
          customerserial: this.customerserial,
          ifsend: this.searchstatus,
          filltemplate: this.searchtype,
          getgroupguids: "1111",
          erpserial: this.erpserial,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          needpackagesize: 1,
          puhuo: this.puhuo,
          paymethod: this.paymethod,
          packagesize: this.getXY(),
          searchremark: this.searchremark,
          inpage: param == 'pagination' ? '1' : '0'
        }).then(request => {
          var th = this.dialogtableHeight(185);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;
          this.tableData = request.data.obj.rows
          if (!(param == 'pagination'))
            this.pagination.total = request.data.obj.total
          // this.tableData.forEach(o => {
          //   o.sumshouru = o.totalmoneytax + o.expressfee
          // })
        })
      },
      getXY() {
        if (this.startX || parseFloat(this.startX) == 0 || this.startY || parseFloat(this.startY) == 0) {//{"X":"0.00","Y":"-0.50"
          var search = "{"
          if (this.startX || parseFloat(this.startX) == 0) {
            search += '"X":"' + parseFloat(this.startX).toFixed(2) + '",';
          } else {
            search += '%,';
          }
          if (this.startY || parseFloat(this.startY) == 0) {
            search += '"Y":"' + parseFloat(this.startY).toFixed(2) + '"';
          } else {
            search += '';
          }
          return search;
        }
        return '';
      },
      getLiuYan(remark) {
        return getRemark(remark).replace(/<br\/>/g, "；");
      },
      lookOrder(index, row) {
        if (row.filltemplate == 50) {
          this.$refs.machiningDetail.initData(row)
          this.$refs.machiningDetail.show()
        } else {
          this.$refs.DataDetail.initData(row)
          this.$refs.DataDetail.show()
        }
      },
      selectOrder(index, row) {
        if (!row.erpserial)
          return;

        printing({
          unitguid: '',
          erpserial: row.erpserial,
          groupguid: '',
          seedcode: ''
        }).then(response => {
          if (response.data.obj.tuihuoorders && response.data.obj.tuihuoorders.length > 0) {
            this.$message({
              message: '订单已申请过退货，不允许选择！',
              type: 'error'
            })
            return;
          }
          if (this.orderNum && this.orderNum > 0) {//2个订单的数量必须一致
            var on = 0;
            for (let i in response.data.obj.goodsDetail) {
              on += parseInt(response.data.obj.goodsDetail[i]["数量"])
            }
            if (on != this.orderNum) {
              this.$message({
                message: '订单商品数量' + on + '，与退货单数量' + this.orderNum + '不一致，不允许选择！',
                type: 'error'
              })
              return;
            }
          }
          this.$emit("afterSelect", row.erpserial, response.data.obj.detail.htje + ' 用券' + response.data.obj.detail.discount);
          this.dialogstoreVisible = false;
        });
      }
    },
    mounted() {
      var end = new Date();//当天
      var start = new Date(end.getFullYear()-1, end.getMonth(), end.getDate());
      this.searchdatevalue = [start, end];
    },
    components: {
      CstagreementEdit,
      JxcgooddetailSel,
      CstagreementMachiningEdit
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/OrderCustomerSelect.vue